(($) ->

  $.fn.showLoader = (classToAdd = '') ->
    self = $ @

    if self.data 'select2'
      if not self.attr 'disabled'
        self.attr 'disabled', 'disabled'
        self.data 'utils-loader-attr-added', ['disabled']
      container = self.next '.select2-container'
      container.prepend '<i data-utils-loader-icon-select2 class="fa fa-circle-o-notch fa-spin utils-loader-icon-select2"></i>'
    else
      style_defined = !!self.attr('style')
      if !style_defined
        width = self.css('width')
        if width
          self.data('loader-width-defined', true)
          self.css({'width', width})

      if classToAdd
        self.addClass classToAdd

      text = self.html()
      self.data 'loader-original-text', text
      self.html '<i class="fa fa-circle-o-notch fa-spin"></i>'

  $.fn.hideLoader = (classToRemove = '') ->
    self = $ @
    if self.data 'select2'
      container = self.next '.select2-container'
      container.find('[data-utils-loader-icon-select2]').remove()
      attr_added = self.data 'utils-loader-attr-added'
      self.data 'utils-loader-attr-added', null
      if _.isArray attr_added
        for attr in attr_added
          self.removeAttr attr
    else
      width_defined = self.data('loader-width-defined')
      if width_defined
        self.removeData('loader-width-defined')
        self.css({'width', 'auto'})

      if classToRemove
        self.removeClass classToRemove

      text = self.data('loader-original-text')
      self.removeData('loader-original-text')
      self.html text

) window.jQuery
